import React, {Component} from "react";
import PropTypes from "prop-types";

class ProgressMatrixView extends Component {

    getBoxSize = (matrixSize) => {
        if (matrixSize === "small") {
            return {
                height: "16px",
                width: "16px",
                margin: "1px"
            }
        }
        return {
            height: "48px",
            width: "48px",
            margin: "4px"
        }
    }

    renderBox = (position, isCompleted, isCurrent, isPending, matrixSize, completionMarkerImage) => {
        const [row, col] = position;
        const boxSize = this.getBoxSize(matrixSize);
        return (
            <div key={`${row}-${col}`} style={{width: boxSize.width, height: boxSize.height,
                backgroundColor: this.getBoxColor(isCurrent, isPending),
                border: this.getBoxBorder(isCurrent, isPending, isCompleted),
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                margin: boxSize.margin, boxSizing: 'border-box',}}>

                {isCompleted && (
                    <img src={completionMarkerImage} alt={"Completed Item"}
                        style={{width: '100%', height: '100%', objectFit: 'contain'}} id='completed-item' aria-hidden="true"/>
                )}
            </div>
        );
    };

    getBoxColor = (isCurrent, isToBeOpened) => {
        if (isCurrent) return '#00BFFF';
        if (isToBeOpened) return '#808080';
        return 'white';
    };

    getBoxBorder = (isCurrent, isToBeOpened, isCompleted) => {
        if (isCompleted) return 'none';
        if (isCurrent || isToBeOpened) return '2px solid #808080';
        return '2px solid white';
    };

    // Helper function to check if a row has pending/completed items
    hasPendingItems = (rowGroups, rowIndex, pendingItems, completedItems) => {
        const rowPositions = rowGroups[rowIndex] || [];
        return rowPositions.some(position =>
            pendingItems.some(item => item[0] === position[0] && item[1] === position[1]) ||
            completedItems.some(item => item[0] === position[0] && item[1] === position[1])
        );
    };

    createGrid = (completedItems, pendingItems, currentPosition, totalItems, matrixSize, completionMarkerImage) => {
        const maxRow = Math.max(...totalItems.map(pos => pos[0]));
        const rowIndices = Array.from({ length: maxRow + 1 }, (_, i) => i).reverse();
        const rowGroups = totalItems.reduce((acc, position) => {
            const [rowIndex] = position;
            if (!acc[rowIndex]) {
                acc[rowIndex] = [];
            }
            acc[rowIndex].push(position);
            return acc;
        }, {});
        return (
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', width: 'fit-content',
                border: '4px solid black', padding: 0, margin: '10px'}}>

                {rowIndices.map(rowIndex => (
                    <div key={rowIndex} style={{display: 'flex', flexDirection: 'row', justifyContent: 'center',
                        borderBottom: (rowIndex === 0 || !this.hasPendingItems(
                            rowGroups, rowIndex - 1, pendingItems, completedItems)) ? 'none' : '2px solid black',
                        padding: '2px', width: '100%'}}>

                        {(rowGroups[rowIndex] || []).map(position => {
                            const [row, col] = position;
                            const isCompleted = completedItems.some(item => item[0] === row && item[1] === col);
                            const isCurrent = currentPosition[0] === row && currentPosition[1] === col;
                            const isPending = pendingItems.some(item => item[0] === row && item[1] === col);
                            return this.renderBox(position, isCompleted, isCurrent, isPending, matrixSize, completionMarkerImage);
                        })}
                    </div>
                ))}
            </div>
        );
    };

    render() {
        const {completedItems, pendingItems, currentPosition, totalItems, matrixSize, completionMarkerImage} = this.props;
        return (
            <div style={{width: '100%', backgroundColor: 'white', display: 'flex', justifyContent: 'center'}}>
                {this.createGrid(completedItems, pendingItems, currentPosition, totalItems, matrixSize, completionMarkerImage)}
            </div>
        );
    }
}

ProgressMatrixView.propTypes = {
    completedItems: PropTypes.arrayOf(PropTypes.array).isRequired,
    pendingItems: PropTypes.arrayOf(PropTypes.array).isRequired,
    currentPosition: PropTypes.arrayOf(PropTypes.number).isRequired,
    totalItems: PropTypes.arrayOf(PropTypes.array).isRequired,
    matrixSize: PropTypes.string,
    completionMarkerImage: PropTypes.string.isRequired,
};

export default ProgressMatrixView;